<template>
  <Teleport to="body">
    <div v-if="mostrar" class="modal-overlay">
      <div :class="['modal-content', { 'modal-fechando': animandoFechamento }]">
        <h2>Dados do Paciente</h2>

        <!-- Abas -->
        <div class="abas">
          <button
            v-for="(aba, index) in abas"
            :key="index"
            :class="{ ativo: abaSelecionada === aba.nome }"
            @click="abaSelecionada = aba.nome"
          >
            {{ aba.label }}
          </button>
        </div>

        <!-- Conteúdo das abas -->
        <div v-if="paciente && Object.keys(paciente).length > 0" class="conteudo">
          <!-- Identificação -->
          <div v-if="abaSelecionada === 'identificacao'">
            <!-- NOME COMPLETO -->
            <div class="campo">
              <span class="icone"><i class="fas fa-user"></i></span>
              <div class="campo-completo">
                <input
                  v-if="modoEdicao || modoCadastro"
                  ref="inputNome"
                  v-model="nomeCompleto"
                  class="input-editar"
                  placeholder="Digite o nome completo"
                  required
                />
                <span v-else>{{ [paciente.primeiro_nome, paciente.sobrenome].filter(Boolean).join(' ') }}</span>
                <p v-if="erroNome && (modoEdicao || modoCadastro)" class="mensagem-erro">{{ erroNome }}</p>
              </div>
            </div>
            <!-- DATA DE NASCIMENTO -->
            <div class="campo">
              <span class="icone"><i class="fas fa-calendar-day"></i></span>
              <input
                v-if="modoEdicao || modoCadastro"
                v-model="pacienteEditado.dn"
                class="input-editar"
                type="date"
              />
              <span v-else>{{ formatarData(paciente.dn) }}</span>
            </div>
            <!-- IDADE -->
            <div class="campo">
              <span class="icone"><i class="fas fa-birthday-cake"></i></span>
              <span>{{ (modoEdicao || modoCadastro) ? idadeCalculada + ' anos' : paciente.idade + ' anos' }}</span>
            </div>
            <!-- SEXO -->
            <div class="campo">
              <span class="icone"><i class="fas fa-venus-mars"></i></span>
              <select v-if="modoEdicao || modoCadastro" v-model="pacienteEditado.sexo" class="input-editar">
                <option value="M">Masculino</option>
                <option value="F">Feminino</option>
                <option value="O">Outro</option>
              </select>
              <span v-else>{{ formatarSexo(paciente.sexo) }}</span>
            </div>
            <!-- UF -->
            <div class="campo">
              <span class="icone"><i class="fas fa-map-marker-alt"></i></span>
              <select v-if="modoEdicao || modoCadastro" v-model="pacienteEditado.uf" class="input-editar">
                <option value="NA">Não Informado</option>
                <option
                  v-for="uf in listaUFs"
                  :key="uf.sigla"
                  :value="uf.sigla"
                >
                  {{ uf.nome }}
                </option>
              </select>
              <span v-else>{{ obterNomeUF(paciente.uf) }}
              </span>
            </div>
          </div>

          <!-- Dados Clínicos -->
          <div v-if="abaSelecionada === 'dados_clinicos'">
            <!-- INDICAÇÃO CLINICA -->
            <div class="campo">
              <span class="icone"><i class="fas fa-stethoscope"></i></span>
              <input
                v-if="modoEdicao || modoCadastro"
                v-model="pacienteEditado.indicacao_clinica"
                class="input-editar"
                placeholder="Digite a indicação clínica"
              />
              <span v-else>{{ paciente.indicacao_clinica || 'Não informado' }}</span>
            </div>
            <!-- FORMA DE CAPTAÇÃO -->
            <div class="campo">
              <span class="icone"><i class="fas fa-bullhorn"></i></span>
              <select v-if="modoEdicao || modoCadastro" v-model="formaDeCapitacao" class="input-editar">
                <option v-for="forma in formasDeCaptacao" :key="forma" :value="forma">{{ forma }}</option>
              </select>
              <span v-else>{{ paciente.forma_de_capitacao || CAPTACAO_PADRAO }}</span>
            </div>

            <!-- SISTEMA INSCRITO -->
            <div class="campo">
              <span class="icone"><i class="fas fa-hospital"></i></span>
              <select v-if="modoEdicao || modoCadastro" v-model="sistemaInscrito" class="input-editar">
                <option v-for="sistema in sistemasInscritos" :key="sistema" :value="sistema">{{ sistema }}</option>
              </select>
              <span v-else>{{ paciente.sistema_inscrito || SISTEMA_PADRAO }}</span>
            </div>
          </div>

          <!-- Contato e Preferências -->
          <div v-if="abaSelecionada === 'contato_preferencias'">
            <!-- EMAIL -->
            <div class="campo">
              <span class="icone"><i class="fas fa-envelope"></i></span>
              <div class="campo-completo">
                <input
                  v-if="modoEdicao || modoCadastro"
                  ref="inputEmail"
                  v-model="pacienteEditado.email"
                  class="input-editar"
                  type="email"
                  required
                  placeholder="Digite o e-mail"
                />
                <span v-else>{{ paciente.email }}</span>
                <!-- ⚠️ Aparece só em edição ou cadastro -->
                <p v-if="erroEmail && (modoEdicao || modoCadastro)" class="mensagem-erro">{{ erroEmail }}</p>
              </div>
            </div>

            <!-- TELEFONE -->
            <div class="campo">
              <span class="icone"><i class="fas fa-phone"></i></span>
              <div class="campo-completo">
                <div v-if="modoEdicao || modoCadastro" class="telefone-wrapper">
                  <span class="prefixo-completa">🇧🇷 +55</span>
                  <input
                    ref="inputTelefone"
                    type="tel"
                    :value="telefone"
                    class="telefone-input"
                    placeholder="(99) 99999-9999"
                    inputmode="numeric"
                    maxlength="15"
                    required
                    @input="onTelefoneInput"
                    @blur="validarAoSair"
                  />
                </div>
                <span v-else>{{ paciente?.telefone_formatado || '—' }}</span>
                <!-- ⚠️ Mensagem de erro só em edição ou cadastro -->
                <p v-if="erroTelefone && (modoEdicao || modoCadastro)" class="mensagem-erro">{{ erroTelefone }}</p>
              </div>
            </div>


            <!-- RECEBER EMAIL -->
                    
            <div class="campo">
              <span class="icone"><i class="fas fa-envelope-open"></i></span>
              <!-- Visualização -->
              <template v-if="!modoCadastro && !modoEdicao">
                <span>Receber Email: {{ formatarPreferencia(paciente.receber_email) }}</span>
              </template>
              <!-- Edição ou Cadastro -->
              <template v-else>
                <label>
                  Receber Email:
                  <input v-model="pacienteEditado.receber_email" type="checkbox" />
                </label>
              </template>
            </div>
            <!-- MOTIVO NÃO EMAIL -->
            <div v-if="!paciente.receber_email" class="campo">
              <span class="icone"><i class="fas fa-exclamation-circle"></i></span>
              <span>Motivo: {{ paciente.motivo_nao_email }}</span>
            </div>
            <!-- RECEBER WHATSAPP -->
            <div class="campo">
              <span class="icone"><i class="fab fa-whatsapp"></i></span>
              <!-- Visualização -->
              <template v-if="!modoCadastro && !modoEdicao">
                <span>Receber WhatsApp: {{ formatarPreferencia(paciente.receber_whatsapp) }}</span>
              </template>
              <!-- Edição ou Cadastro -->
              <template v-else>
                <label>
                  Receber WhatsApp:
                  <input v-model="pacienteEditado.receber_whatsapp" type="checkbox" />
                </label>
              </template>
            </div>
            <!-- MOTIVO NÃO WHATSAPP -->
            <div v-if="!paciente.receber_whatsapp" class="campo">
              <span class="icone"><i class="fas fa-exclamation-circle"></i></span>
              <span>Motivo: {{ paciente.motivo_nao_whatsapp }}</span>
            </div>
          </div>
        </div>
        <p v-if="erroGeral" class="mensagem-erro-centralizada">{{ erroGeral }}</p>
        <!-- Botões -->
        <div class="botoes-modal" :class="{ single: !modoEdicao && !modoCadastro }">
          <!-- Visualização (sem edição nem cadastro) -->
          <template v-if="!modoEdicao && !modoCadastro">
            <button type="button" class="btn-fechar" @click="fecharModal">
              Fechar
            </button>
          </template>

          <!-- Modo Edição -->
          <template v-else-if="modoEdicao">
            <button type="button" class="btn-salvar" @click="salvarAlteracoes">
              Salvar Alterações
            </button>
            <button type="button" class="btn-cancelar" @click="fecharModal">
              Cancelar
            </button>
          </template>

          <!-- Modo Cadastro -->
          <template v-else-if="modoCadastro">
            <button type="button" class="btn-salvar" @click="cadastrarPaciente">Cadastrar Paciente</button>
            <button type="button" class="btn-cancelar" @click="fecharModal">Cancelar</button>
          </template>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import axios from 'axios'
import Swal from 'sweetalert2'
import dayjs from "dayjs"
import "dayjs/locale/pt-br"
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import { prepararPaciente } from '@/utils/prepararPaciente'
import { listaUFs, obterNomeUF } from '@/utils/ufs'
import { useSistemasInscritos, SISTEMA_PADRAO } from '@/composables/useSistemasInscritos'
import { useFormasDeCaptacao, CAPTACAO_PADRAO } from '@/composables/useFormasDeCaptacao'

// Carregar dados das APIs
const { sistemas: sistemasInscritos, carregar: carregarSistemas } = useSistemasInscritos()
const { formas: formasDeCaptacao, carregar: carregarFormas } = useFormasDeCaptacao()
carregarSistemas()
carregarFormas()

const telefone = ref("")
const inputNome = ref(null)
const inputTelefone = ref(null)
const inputEmail = ref(null)
const abaSelecionada = ref("identificacao")
const pacienteEditado = ref({})
const erroNome = ref("")
const erroEmail = ref("")
const erroTelefone = ref("")
const erroGeral = ref("")


// 👇 Computed que junta e separa automaticamente
const nomeCompleto = computed({
  get: () => {
    const nome = pacienteEditado.value.primeiro_nome || '';
    const sobrenome = pacienteEditado.value.sobrenome || '';
    return `${nome} ${sobrenome}`.trim();
  },
  set: (valor) => {
    const { primeiro_nome, sobrenome } = separarNomeCompleto(valor);
    pacienteEditado.value.primeiro_nome = primeiro_nome;
    pacienteEditado.value.sobrenome = sobrenome;
  }
});


function resetarFormulario() {
  pacienteEditado.value = {}
  telefone.value = ""
  erroNome.value = ""
  erroEmail.value = ""
  erroTelefone.value = ""
  erroGeral.value = ""
  abaSelecionada.value = "identificacao"
}

// Limpa e limita a 11 dígitos (sem DDI, pois já é fixo)
function formatarTelefone(numero) {
  const limpo = numero.replace(/\D/g, '').slice(0, 11)
  return limpo
    .replace(/^(\d{2})(\d)/g, '($1) $2')
    .replace(/(\d{5})(\d{0,4})$/, '$1-$2')
}

// Resultado final para backend
const numeroLimpo = computed(() => {
  const local = telefone.value.replace(/\D/g, '').slice(0, 11)
  return `55${local}` // Sempre começa com 55
})

// Validação (13 dígitos com DDI + DDD + número)
const telefoneValido = computed(() => {
  const parsed = parsePhoneNumberFromString('+' + numeroLimpo.value, 'BR')
  return parsed?.isValid() || false
})

// Input handler
function onTelefoneInput(e) {
  telefone.value = formatarTelefone(e.target.value)
  erroTelefone.value = ''
  pacienteEditado.value.telefone_formatado = numeroLimpo.value
}

// Opcional: validar ao sair do campo
function validarAoSair() {
  if (!telefoneValido.value) {
    erroTelefone.value = 'Telefone inválido'
  }
}

// Quando editar paciente, preenche input
watch(() => pacienteEditado.value.telefone_formatado, (val) => {
  if (val?.startsWith('55')) {
    const nacional = val.slice(2)
    telefone.value = formatarTelefone(nacional)
  }
})


function separarNomeCompleto(nomeCompleto) {
  const [primeiro_nome, ...resto] = nomeCompleto.trim().split(' ');
  return {
    primeiro_nome,
    sobrenome: resto.join(' ')
  };
}

const formaDeCapitacao = computed({
  get() {
    return pacienteEditado.value.forma_de_capitacao || CAPTACAO_PADRAO;
  },
  set(novoValor) {
    pacienteEditado.value.forma_de_capitacao = novoValor;
  }
});

const sistemaInscrito = computed({
  get() {
    return pacienteEditado.value.sistema_inscrito || SISTEMA_PADRAO;
  },
  set(novoValor) {
    pacienteEditado.value.sistema_inscrito = novoValor;
  }
});


const idadeCalculada = computed(() => {
  if (!pacienteEditado.value.dn) return null
  const hoje = dayjs()
  const nascimento = dayjs(pacienteEditado.value.dn)
  return hoje.diff(nascimento, 'year')
})

const props = defineProps({
  paciente: { type: Object, default: () => ({}) },
  mostrar: { type: Boolean, default: false },
  modoEdicao: { type: Boolean, default: false },
  modoCadastro: { type: Boolean, default: false },
  pacientesExistentes: { type: Array, default: () => [] }
});

const emit = defineEmits([
  'update:mostrar', // 👈 padrão do v-model:mostrar
  'update:paciente', // para v-model:paciente
  'atualizar-paciente',
  'cadastrar-paciente',
])

const animandoFechamento = ref(false)


const fecharModal = () => {
  animandoFechamento.value = true
  setTimeout(() => {
    animandoFechamento.value = false
    resetarFormulario() // 🔁 limpa tudo aqui
    emit("update:mostrar", false)
  }, 300)
}

const ocultarModalVisualmente = async () => {
  animandoFechamento.value = true
  await new Promise(resolve => setTimeout(resolve, 150))
  emit("update:mostrar", false)
}


const formatarData = (data) => data ? dayjs(data).format("DD/MM/YYYY") : "Data não informada"
const formatarSexo = (sexo) => ({ M: "Masculino", F: "Feminino", O: "Outro" })[sexo] || "Não informado"
const formatarPreferencia = (valor) => valor ? "Sim" : "Não"

const abas = [
  { nome: "identificacao", label: "Identificação" },
  { nome: "dados_clinicos", label: "Dados Clínicos" },
  { nome: "contato_preferencias", label: "Contato e Preferências" }
]



// Watch para atualizar pacienteEditado
watch(
  () => props.paciente,
  (novoPaciente) => {
    if (props.mostrar && novoPaciente) {
      pacienteEditado.value = JSON.parse(JSON.stringify(novoPaciente))
    }
  },
  { immediate: true }
)




// === ✅ SALVAR ALTERAÇÕES (modo edição) ===
const salvarAlteracoes = async () => {

  erroNome.value = ""
  erroEmail.value = ""
  erroTelefone.value = ""
  erroGeral.value = ""

  const { primeiro_nome, email, telefone_formatado } = pacienteEditado.value;
  const pacientePayload = prepararPaciente(pacienteEditado.value)

  // 📋 Verificação básica
  if (!email || !telefone_formatado) {
    erroGeral.value = "*Verifique os preenchimentos obrigatórios";
    return;
  }
  // 🧑‍⚕️ Nome obrigatório
  if (!primeiro_nome?.trim()) {
    erroNome.value = "*O nome é obrigatório";
    inputNome.value?.focus();
    return;
  }

   // ✉️ Validação de e-mail
  if (!email) {
    erroEmail.value = "E-mail é obrigatório";
    inputEmail.value?.focus();
    return;
  }

  // ✉️ E-mail válido
  const emailValido = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  if (!emailValido) {
    erroEmail.value = "Formato de e-mail inválido";
    inputEmail.value?.focus();
    return;
  }

  // ☎️ Validação de telefone
  if (!telefone_formatado) {
    erroTelefone.value = "Telefone é obrigatório";
    inputTelefone.value?.focus();
    return;
  }


  await ocultarModalVisualmente()

  const confirmacao = await Swal.fire({
    title: 'Deseja salvar as alterações?',
    text: 'As informações serão atualizadas permanentemente.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#4caf50',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Sim, salvar',
    cancelButtonText: 'Cancelar'
  });

  if (!confirmacao.isConfirmed) {
    resetarFormulario()
    fecharModal()
    return
  }

  try {

    if (!pacientePayload.id) {
      await Swal.fire("Erro!", "ID do paciente não foi encontrado.", "error");
      return;
    }

    const response = await axios.put(`/api/pacientes/${pacientePayload.id}`, pacientePayload, {
      headers: { "Accept": "application/json" }
    });

    emit("atualizar-paciente", response.data.paciente);
    fecharModal();

  } catch (error) {
    if (!error._handled) {
      const msg = error.response?.data?.message || error.message;
      Swal.fire("Erro!", msg, "error");
    }
  }
};

// === ✅ CADASTRAR PACIENTE (modo criação) ===
const cadastrarPaciente = async () => {
  let erroDetectado = false
  erroNome.value = ""
  erroEmail.value = "";
  erroTelefone.value = "";
  erroGeral.value = "";

  const { primeiro_nome, email, telefone_formatado } = pacienteEditado.value;
  const pacientePayload = prepararPaciente(pacienteEditado.value)
  pacientePayload.data_cadastro = dayjs().toISOString()



  // 🧑‍⚕️ Nome obrigatório
  if (!primeiro_nome?.trim()) {
    erroNome.value = "*O nome é obrigatório";
    inputNome.value?.focus();
    erroDetectado = true
  }

  // ✉️ Validação de e-mail
  if (!email) {
    erroEmail.value = "*E-mail é obrigatório.";
    inputEmail.value?.focus();
    erroDetectado = true
  }
  // ✉️ E-mail válido
  const emailValido = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  if (!emailValido) {
    erroEmail.value = "*Formato de e-mail inválido.";
    inputEmail.value?.focus();
    erroDetectado = true
  }

  // ☎️ Validação de telefone
  if (!telefone_formatado) {
    erroTelefone.value = "*O telefone é obrigatório.";
    inputTelefone.value?.focus();
    erroDetectado = true
  }

  // ⚠️ Erro geral, se algum campo estiver vazio
  if (erroDetectado) {
    erroGeral.value = "*Verifique os preenchimentos obrigatórios"
    return
  }



  // 🔒 Verifica duplicidade
  const duplicado = props.pacientesExistentes.find(p =>
    p.email === pacienteEditado.value.email ||
    p.telefone_formatado === pacienteEditado.value.telefone_formatado
  )

  if (duplicado) {
    erroGeral.value = "Já existe um paciente com este e-mail ou telefone."
    await Swal.fire("Erro!", erroGeral.value, "error")
    return
  }

  await ocultarModalVisualmente()

  // ✅ Confirmação visual
  const confirmacao = await Swal.fire({
      title: 'Deseja cadastrar este paciente?',
      text: 'O paciente será adicionado ao sistema.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#4caf50',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, cadastrar',
      cancelButtonText: 'Cancelar'
  });

  if (!confirmacao.isConfirmed) {
    resetarFormulario()
    fecharModal()
    return
  }

  try {
    const response = await axios.post("/api/pacientes", pacientePayload, {
      headers: { "Accept": "application/json" }
    });

    emit("cadastrar-paciente", response.data);
    fecharModal();

  } catch (error) {
    if (!error._handled) {
      const msg = error.response?.data?.message || error.message;
      Swal.fire("Erro!", msg, "error");
    }
  }
};

watch(
  () => props.mostrar,
  (aberto) => {
    if (!aberto) {
      resetarFormulario()
      return
    }

    if (props.modoCadastro) {
      pacienteEditado.value = prepararPaciente({})
    } else if (props.modoEdicao && props.paciente) {
      pacienteEditado.value = prepararPaciente(props.paciente)
    }
  },
  { immediate: true }
)


// Limpa erro geral ao preencher nome, email ou telefone
watch(nomeCompleto, () => {
  if (erroGeral.value) erroGeral.value = ""
  erroNome.value = ""
})

watch(() => pacienteEditado.value.email, () => {
  if (erroGeral.value) erroGeral.value = ""
  erroEmail.value = ""
})

watch(telefone, () => {
  if (erroGeral.value) erroGeral.value = ""
  erroTelefone.value = ""
})

</script>


<style scoped>

.campo-completo {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
}

.mensagem-erro {
  color: #e53935; /* tom de vermelho bonito */
  font-size: 0.875rem;
  margin: 4px 0px 0px 32px;
  padding-left: 6px;
}

/* Fields */
.campo {
  display: flex;
  align-items: center;
  background: var(--field-bg, #f8f8f8);
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 10px;
  font-size: 15px;
}



.telefone-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 6px;
  overflow: hidden;
  background-color: #fff;
}

.prefixo-completa {
  padding: 10px 12px;
  background: #f0f0f0;
  font-size: 14px;
  border-right: 1px solid #ccc;
  display: flex;
  align-items: center;
}

.telefone-input {
  flex: 1;
  border: none;
  padding: 10px;
  font-size: 14px;
  outline: none;
  font-family: inherit;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  transition: opacity 0.3s ease;
}

.modal-content {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  width: 90%;
  max-width: 650px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
  transform: scale(1);
  opacity: 1;
  transition: all 0.3s ease;
}

/* Animação de fechamento */
.modal-content.modal-fechando {
  transform: scale(0.96);
  opacity: 0;
}

/* Extra opcional: animação na overlay */
.modal-overlay.ocultando {
  opacity: 0;
}
.mensagem-erro-centralizada {
  color: #e53935;
  font-size: 0.9rem;
  text-align: center;
  margin-top: 10px;
  margin-bottom: -5px;
}

.botoes-modal.single {
  justify-content: center;
}

.swal2-container {
  z-index: 9999 !important;
}

.input-editar {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 15px;
  flex: 1;
}

/* Overlay */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/* Modal container */
.modal-content {
  background: var(--bg, white);
  color: var(--text, #333);
  padding: 20px;
  border-radius: 10px;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.4);
  animation: fadeSlideIn 0.3s ease-out;
  position: relative;
  transition: background 0.3s, color 0.3s;
}

/* Dark mode override */
.dark-mode .modal-content {
  --bg: #1e1e1e;
  --text: #f1f1f1;
}

/* Tabs */
.abas {
  display: flex;
  gap: 10px;
  justify-content: space-between;
  border-bottom: 2px solid #ccc;
  padding-bottom: 6px;
  margin-bottom: 15px;
}

.abas button {
  flex: 1;
  background: none;
  border: none;
  padding: 10px;
  cursor: pointer;
  font-weight: bold;
  text-align: center;
  color: inherit;
  border-bottom: 3px solid transparent;
  transition: color 0.2s, border-bottom 0.2s;
}

.abas .ativo {
  color: #4caf50;
  border-bottom-color: #4caf50;
}


.dark-mode .campo {
  --field-bg: #2a2a2a;
}

/* Icon */
.icone {
  width: 30px;
  text-align: center;
  margin-right: 10px;
}

.icone i {
  font-size: 18px;
  color: #666;
}

/* Button area */
.botoes-modal {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 20px;
  flex-wrap: wrap;
}
.botoes-modal.single {
  justify-content: center;
}
.btn-fechar,
.btn-salvar,
.btn-cancelar {
  flex: 1 1 auto;
  padding: 10px 15px;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  cursor: pointer;
  transition: background 0.3s;
  min-width: 100px;
}

.btn-fechar {
  background: #4caf50;
  color: white;
}

.btn-salvar {
  background: #2196f3;
  color: white;
}

.btn-cancelar {
  background: #e53935;
  color: white;
}

.btn-fechar:hover {
  background: #388e3c;
}

.btn-salvar:hover {
  background: #1976d2;
}

.btn-cancelar:hover {
  background: #c62828;
}

/* Animation */
@keyframes fadeSlideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeSlideOut {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(20px);
  }
}

.modal-fechando {
  animation: fadeSlideOut 0.3s ease-in forwards;
}

/* Mobile adjustments */
@media (max-width: 700px) {
  .modal-content {
    border-radius: 0;
    padding: 16px;
    width: 100%;
    max-width: 100%;
    height: 100vh;
    max-height: 100vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }

  .modal-content h2 {
    font-size: 18px;
    margin-bottom: 10px;
  }

  .abas {
    gap: 4px;
    margin-bottom: 12px;
  }

  .abas button {
    padding: 8px 4px;
    font-size: 12px;
  }

  .conteudo {
    flex: 1;
    overflow-y: auto;
  }

  .campo {
    padding: 10px;
    font-size: 14px;
  }

  .input-editar {
    font-size: 16px; /* Evita zoom no iOS */
    padding: 10px;
  }

  .telefone-input {
    font-size: 16px; /* Evita zoom no iOS */
    padding: 12px 10px;
  }

  .prefixo-completa {
    padding: 10px;
    font-size: 13px;
  }

  .botoes-modal {
    flex-direction: column;
    gap: 8px;
    margin-top: 16px;
    padding-bottom: env(safe-area-inset-bottom, 0px);
  }

  .btn-fechar,
  .btn-salvar,
  .btn-cancelar {
    width: 100%;
    min-height: 48px;
    font-size: 16px;
  }
}
@media (max-width: 1810px) {
  .modal-content {
    max-width: 500px; /* 🔽 reduzido */
    padding: 20px;
  }

  .input-editar {
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 12px;
    flex: 1;
  }
}

</style>